var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-wrap login-page" },
    [
      _c(
        "v-card",
        { attrs: { width: "600px" } },
        [
          _c("v-card-title", { staticClass: "headline grey lighten-2 px-8" }, [
            _vm._v(" Reset Password ")
          ]),
          _vm._v(" "),
          _c("v-divider"),
          _vm._v(" "),
          _c("div", { staticClass: "container px-8" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-sm-12" },
                [
                  _c("v-text-field", {
                    attrs: {
                      label: "Username",
                      "error-messages": _vm.usernameErrors
                    },
                    on: {
                      input: function($event) {
                        return _vm.$v.username.$touch()
                      },
                      blur: function($event) {
                        return _vm.$v.username.$touch()
                      }
                    },
                    model: {
                      value: _vm.username,
                      callback: function($$v) {
                        _vm.username = $$v
                      },
                      expression: "username"
                    }
                  })
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "v-card-actions",
            { staticClass: "headline grey lighten-2 px-8" },
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "primary",
                    text: "",
                    link: "",
                    to: "/register"
                  }
                },
                [_vm._v(" Sign In ")]
              ),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "primary", text: "" },
                  on: {
                    click: function($event) {
                      return _vm.submit()
                    }
                  }
                },
                [_vm._v(" Reset Password ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }